import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import {
  PASSWORD_POLICY_RULES,
  evaluatePasswordPolicy,
  type PasswordPolicyRule,
} from '../lib/password-policy';
import { cn } from '@shared/lib/utils';

interface PasswordPolicyChecklistProps {
  password: string;
  failedRules?: PasswordPolicyRule[];
}

export function PasswordPolicyChecklist({ password, failedRules = [] }: PasswordPolicyChecklistProps) {
  const { t } = useTranslation('auth');
  const status = evaluatePasswordPolicy(password);
  const active = password.length > 0 || failedRules.length > 0;

  return (
    <ul className="mt-2 space-y-1" aria-label={t('recovery.policyLabel')}>
      {PASSWORD_POLICY_RULES.map((rule) => {
        const failed = failedRules.includes(rule) || (password.length > 0 && !status[rule]);
        const passed = active && !failed;

        return (
          <li
            key={rule}
            className={cn(
              'flex items-center gap-2 text-xs',
              !active && 'text-muted-foreground',
              failed && 'text-destructive',
              passed && 'text-foreground',
            )}
          >
            <Check className={cn('h-3.5 w-3.5 shrink-0', !passed && 'opacity-40')} aria-hidden />
            <span>{t(`recovery.policy.${rule}`)}</span>
          </li>
        );
      })}
    </ul>
  );
}
